module.exports = __webpack_public_path__ + "img/stickman.c733824a.svg";